var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Faq',{attrs:{"title":"Frequently Asked Questions","subtitle":"Lorem ipsum dolor sit amet consectetur adipisicing elit. Natus impedit error labore doloremque fugit! Dolor fugit molestiae vero quos quisquam nobis, eos debitis magni omnis ea incidunt amet voluptate dignissimos!","faq":_vm.faq}})
}
var staticRenderFns = []

export { render, staticRenderFns }